import React, { useState } from "react";
import axios from "axios";
import "./FormInfoModal.css";
import logo from "../assets/images/logo.png"; 

const FormInfoModal = ({ isOpen, onClose }) => {
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [programa, setPrograma] = useState("");
  const [mensaje, setMensaje] = useState("");

  if (!isOpen) return null;

  const enviarFormulario = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://www.iestpjva.edu.pe/backend/api/enviar_info.php",
        { nombre, correo, programa, mensaje }
      );

      if (res.data.status === "ok") {
        alert("Solicitud enviada correctamente.");
        onClose();
      } else {
        alert("Error al enviar el formulario.");
      }
    } catch (err) {
      alert("Error en el servidor.");
      console.log(err);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

      
        <img src={logo} alt="Logo" className="modal-logo" />

        <h2 className="modal-title">SOLICITAR INFORMACIÓN</h2>

        <form onSubmit={enviarFormulario}>
          <input
            type="text"
            placeholder="Tu nombre completo"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Correo electrónico"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
          />

          <select
            value={programa}
            onChange={(e) => setPrograma(e.target.value)}
            required
          >
            <option value="">Selecciona un programa</option>
            <option>Arquitectura de Plataformas y STI</option>
            <option>Contabilidad</option>
            <option>Enfermería Técnica</option>
            <option>Mecatrónica Automotriz</option>
            <option>Farmacia Técnica</option>
          </select>

          <textarea
            placeholder="Mensaje (opcional)"
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
          ></textarea>

          <button type="submit" className="btn-enviar">
            Enviar Solicitud
          </button>
        </form>

        <button className="btn-cerrar" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default FormInfoModal;
